export default (props, vars) => props?.['student'].linkedinUrl;
